import { UUID } from '../shared/UUID';
import { eUserType } from '../../ui-toolkit/orders/interfaces/eUserType';

export interface IOrderCreatorResponse {
  id?: UUID;
  name: string;
  type?: eUserType;
}

export type IOrderCreatorData = IOrderCreatorResponse;

export const convertIOrderCreatorResponseToIOrderCreatorData = (response: IOrderCreatorResponse): IOrderCreatorData =>
  response;
